import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUserInfo } from 'services/store/features/kyc/user/actions';
import { fetchEntities } from 'services/store/features/kyc/entity/actions';
import Navigation from './Navigation';
var mapStateToProps = function (state) { return ({
    status: state.kycUser.status,
    statusSocieties: state.kycEntity.status,
    societies: state.kycEntity.entities || [],
}); };
var mapDispatchToProps = function (dispatch) { return ({
    actions: bindActionCreators({ fetchUserInfo: fetchUserInfo, fetchEntities: fetchEntities }, dispatch),
}); };
export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
